module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_VITAAKTIV.a19cf4df.png";